<template>
    <div class="layout">
        <div class="page-4 page">
            <Header :activeIndex="'2'"></Header>
            <div :class="showBG?'page-section bg':'page-section'">
                <video autoplay loop muted :class="vdaH?'hide':''">
                    <source src="https://jy-datav-images.oss-cn-shanghai.aliyuncs.com/jinfucloud/%E8%B6%85%E7%BA%A7%E8%AE%A1%E7%AE%97%E4%BA%91.mp4" type="video/mp4">
                    您的浏览器不支持Video标签。
                </video>
                <div :class="vdaH?'section-tab H':'section-tab'">
                    <div class="section-center">   
                        <div class="section-cont first-section">
                            <div class="banner-txt">
                                <div class="l">
                                    <h2>计算资源层</h2>
                                    <h4>超级计算云 + 数金云</h4>
                                </div>
                                <!-- <p>计算资源层提供基于云原生的多云方案，包括国家超算中心广州中心的超算云、国内三大运营商的云服务。多云方案为基础设施平台的数据治理层提供安全合规的云环境；超算云服务具有独特的高压缩存储技术，灵活调用的千万个超算节点，能够很好的满足智能分析引擎对算力的要求，是智能引擎层的算力保证；同时让地方金融机构只需低成本即可享用应用响应层的公共应用系统服务。基于云原生的多云方案基础设施能力，能够优化组合各云服务优势、效率与成本，最终实现综合成本、安全合规、运行效率整体最优。</p> -->
                
                            </div>
                        </div>  
                    </div>   
                </div>
                <div class="section-sub-tab" id="section-sub-tab">
                    <div class="sec-bot">
                        <div class="section-center">
                            <p style="text-indent: 35px;font-size:1rem;line-height: 1.8;">计算资源层提供基于云原生的多云方案，包括国家超算中心广州中心的超算云、联通数金云服务。多云方案为基础设施平台的数据治理层提供安全合规的云环境；超算云服务具有独特的高压缩存储技术，灵活调用的千万个超算节点，能够很好的满足智能分析引擎对算力的要求，是智能引擎层的算力保证；同时让地方金融机构只需低成本即可享用应用响应层的公共应用系统服务。基于云原生的多云方案基础设施能力，能够优化组合各云服务优势、效率与成本，最终实现综合成本、安全合规、运行效率整体最优。</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
import { Header, Footer } from "../common/common.js";

  export default {
    components: {
        Header,
        Footer,
    },
    name: '',
    data () {
      return {
        showBG: false,
        vdaH: false
      }
    },
    mounted() {
        this.$nextTick(()=>{
            setTimeout(()=>{
                this.showBG = true
            },1000)
        })
        this.browserRedirect()
        const that = this;
        window.addEventListener('resize',function(){
            that.browserRedirect()
        },false)
    },
    methods: {
        browserRedirect() {
            var sUserAgent = navigator.userAgent.toLowerCase();
            // alert(sUserAgent)
            
            if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
                //跳转移动端页面
                this.vdaH = true
            } else {
                //跳转pc端页面
                this.vdaH = false
            }
        }
    }
        

  }
</script>

<style>
    .page-4 .page-section {
        position: relative;
        /* width: 100%; */
        /* max-height: 100vh; */
        overflow: hidden;
        min-width: 1200px;
        
    }
    .page-4 .page-section.bg {
        background: url('../../assets/img/BG7.png') no-repeat;
        background-size: 100% 100%;
    }
    .page-4 video {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        -o-object-fit: fill;
        object-fit: fill;
        width: auto;
        height: auto;
        -webkit-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
    }
    .page-4 .section-tab {
        position: relative;
        /* width: 100%; */
        /* height: 100vh; */
        height: 86.7592vh;
        color: #fff;
        /* background-size: 100% 100%; */
        overflow: hidden;
        min-width: 1200px;
        /* background: url('../../assets/img/BG7.png') no-repeat; */
        /* background: red; */
    }
    .page-4 .section-tab.H {
        height: 92vh;
    }
    .page-4 .page-section .section-center , .page-4 .page-section .section-cont {
        width: 100%;
        height: 100%;
    }
    .page-4 .page-section .banner-txt {
        width: 100%;
        height: 100%;
        position: relative;
    }
    .page-4 .page-section .l {
        width: 1200px;
        position: absolute;
        left: 50%;
        top: 30%;
        transform: translateX(-50%);
    } 
    .page-4 .page-section .l h2 {
        font-size: 30px;
        font-weight: 700;
        color: #fff;
        margin-bottom: 15px;
    }
    .page-4 .page-section .l h4 {
        font-size: 24px;
        font-weight: 400;
        color: #fff;
        margin-top: 0;
    }
    .page-4 .page-section .section-sub-tab p {
        text-indent: 35px;
        width: 1200px;
        position: absolute;
        left: 50%;
        bottom: 3%;
        transform: translateX(-50%);
        color: #fff;
    }
    .page-section .section-sub-tab {
        background: unset;
       
    }
    .page-4 .page-section .section-sub-tab {
        /* height: 11.4889vh; */
    }
    @media screen and (max-width: 768px) {
        .page-4 .page-section {
            min-width: 100% !important;
            width: 100% !important;
            padding: 0 !important;
            margin: 0 !important;
            min-height: auto !important;
            height: auto !important;
            overflow-x: hidden !important;
        }
        .page-4 .page-section.bg {
            background: url('../../assets/img/BG7.png') no-repeat !important;
            background-size: cover !important;
            background-position: center !important;
        }
        .page-4 video {
            display: none !important;
        }
        .page-4 .section-tab {
            height: 270px !important;
            min-height: 270px !important;
            max-height: none !important;
            padding-top: 70px !important;
            min-width: 100% !important;
            width: 100% !important;
            background-size: cover !important;
            background-position: center !important;
            position: relative !important;
            overflow-x: hidden !important;
        }
        .page-4 .section-tab.H {
            height: 270px !important;
        }
        .page-4 .page-section .banner-txt {
            width: 100% !important;
            height: auto !important;
            position: relative !important;
            padding-top: 20px !important;
        }
        .page-4 .page-section .l {
            width: 100% !important;
            position: static !important;
            left: auto !important;
            top: auto !important;
            transform: none !important;
            padding: 10px !important;
            box-sizing: border-box !important;
            text-align: center !important;
        }
        .page-4 .page-section .l h2 {
            font-size: 24px !important;
            text-align: center !important;
        }
        .page-4 .page-section .l h4 {
            font-size: 18px !important;
            text-align: center !important;
        }
        .page-4 .section-sub-tab {
            min-width: 100% !important;
            width: 100% !important;
            min-height: 0 !important;
            height: auto !important;
            padding: 20px 10px !important;
            margin: 0 !important;
            background: #f5f5f5 !important;
            position: relative !important;
            clear: both !important;
            margin-top: 20px !important;
            top: 0 !important;
        }
        .page-4 .page-section .section-sub-tab p {
            width: 100% !important;
            position: static !important;
            left: auto !important;
            bottom: auto !important;
            transform: none !important;
            padding: 0 !important;
            box-sizing: border-box !important;
            font-size: 14px !important;
            line-height: 1.6 !important;
            text-indent: 0 !important;
            color: #333 !important;
        }
        .page-4 .page-section .section-center {
            width: 100% !important;
            max-width: 100% !important;
            padding: 0 !important;
            margin: 0 !important;
            height: auto !important;
        }
        .page-4 .page-section .section-cont {
            width: 100% !important;
            height: auto !important;
        }
        .page-4 .common-head {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            z-index: 9999 !important;
            background: rgba(0,0,0,0.9) !important;
            height: 70px !important;
            line-height: 70px !important;
            overflow: visible !important;
            border-bottom: none !important;
        }
        .page-4 .common-head .flex-box {
            width: 100% !important;
            max-width: 100% !important;
            padding: 0 10px !important;
            box-sizing: border-box !important;
            height: 100% !important;
            position: relative !important;
        }
        .page-4 .common-head .flex-box .logo {
            width: 40% !important;
            max-width: 200px !important;
            height: 100% !important;
            background-size: contain !important;
            background-repeat: no-repeat !important;
            background-position: left center !important;
        }
        .page-4 .common-head .nav-list {
            width: 60% !important;
            float: right !important;
            display: block !important;
            position: absolute !important;
            right: 10px !important;
            top: 0 !important;
        }
        .page-4 .common-head .nav-list ul {
            margin: 0 !important;
            padding: 0 !important;
            display: flex !important;
            align-items: center !important;
            height: 70px !important;
        }
        .page-4 .common-head .nav-list li {
            float: left !important;
            padding: 0 !important;
            margin-left: 8px !important;
            font-size: 11px !important;
            line-height: 70px !important;
            height: 70px !important;
            list-style: none !important;
        }
        .page-4 .common-head .nav-list li a {
            color: #333 !important;
            text-decoration: none !important;
        }
        .page-4 .common-head .flex-box .cont-center {
            display: none !important;
        }
        .page-4 .common-foot {
            min-width: 100% !important;
            width: 100% !important;
        }
        .page-4 .common-foot .foot-center {
            width: 100% !important;
            flex-direction: column !important;
        }
        .page-4 .common-foot .foot-center > div {
            width: 100% !important;
            border-right: none !important;
            border-bottom: 1px solid #e8e8e8 !important;
            padding: 10px !important;
            box-sizing: border-box !important;
        }
        .page-4 .common-foot .p-r {
            padding-left: 0 !important;
        }
        .page-4 .common-foot .p-ab {
            position: static !important;
            text-align: left !important;
        }
    }
</style>

